
//Banner
import BannerImage from "../assets/images/OneFifty_Contact/Banner.png"

//Components
import Form from "../components/Form";
import Footer from "../components/Footer";
import QuickNav from "../components/QuickNav";
import ParrallaxBanner from "../components/ParrallaxBanner";

//React Imports
import { Helmet } from "react-helmet";

let QuickLinks = {
  backgroundColor: "cyan",
  prev: {
    title: "Neighborhood",
    url: "/neighborhood"
  },
  next: {
    title: "Home",
    url: "/"
  },
  parrallax : true,
}
let footerData = {
  backgroundColor: "green",
  parrallax : true,
}
let BannerData = {
  backgroundImage: BannerImage,
  backgroundColor: "normal",
  heading: "You Deserve <span>the</span> Best",
  description: "Ready for a change? Use the contact form below and click “submit” to receive more information about renting a Bushwick apartment at One Fifty and starting your next chapter in Brooklyn.",
  color: "green",
}
let isParallax = {
  parrallax : true,
}
export default function Contact() {
  return (
    <>
      <Helmet>
        <title>Contact Us | One Fifty Brooklyn Apartments - EXR</title>
        <meta name="description" content="Let us help you rent a luxury Bushwick apartment at 150 Noll Street in Brooklyn." />
      </Helmet>
      <ParrallaxBanner data={BannerData} />
      <Form ifParrallax={isParallax} />
      <QuickNav links={QuickLinks} />
      <Footer data={footerData} />
    </>
  );
} 